import React from 'react'
import { useTranslation } from "react-i18next"
import { Dialog } from '@progress/kendo-react-dialogs'
import { Grid } from '@material-ui/core'
import './dialog-delete-signer.css'
import ButtonHLPure from '../buttonHL/buttonHL.pure'

/* === Custom component title for dialog === */
const CustomDeleteSignerTitleBar = (props) => {
    const { t } = useTranslation()
    return (<div><span>{t('dialogDeleteSigner.dialogTittleDeleteSigner')}</span></div>)
}

const DialogDeleteSignerPure = (props) => {
    const { t } = useTranslation()

    return (
        <div>
            {props.visibleDialogDeleteSigner &&
                <Dialog title={<CustomDeleteSignerTitleBar />} width={400} height={345} onClose={props.toggleDialogDeleteSigner} className='dialog-deleteSigner'>
                    <Grid container xs={12} lg={12} md={12} sm={12} es={12} className='container-dialogDeleteSigner'>
                        {/* Label */}
                        <Grid item xs={12} lg={12} md={12} sm={12} es={12} className='item-description-dialogDeleteSigner'>
                            <p className='text-dialogDeleteSigner'>
                                {t('dialogDeleteSigner.AreYouShureToDeleteSigner')}
                                <span className='label-userDelete'> {props.signerToDelete.nameSigner} ({props.signerToDelete.email}) </span>
                                {t('dialogDeleteSigner.OfTheSignRequest')}
                            </p>
                        </Grid>

                        {/* Buttons group */}
                        <Grid item xs={12} lg={12} md={12} sm={12} es={12} className='group-btns-dialogDeleteSigner'>
                            <ButtonHLPure
                                nameBtn={t('dialogDeleteSigner.buttonCancel')}
                                onClickBtn={props.toggleDialogDeleteSigner}
                                primary={false}
                            />
                            <ButtonHLPure
                                nameBtn={t('dialogDeleteSigner.buttonAccept')}
                                onClickBtn={props.remove}
                                primary={true}
                            />
                        </Grid>
                    </Grid>
                </Dialog>
            }
        </div>
    )
}
export { DialogDeleteSignerPure as default }